// Club initials for the "no logo" placeholder badge.
//
// A club only has `club.logo` when it is linked to a Wyscout team; a
// self-registered club has none, and a raw `<img src={undefined}>` then renders
// the browser's broken-image glyph next to the alt text. The fix is an initials
// badge, and TenderDetailsModal.js:62 already derived those initials inline for
// exactly that purpose. This is the same derivation, in one place, so the next
// call site does not become a third copy.

/** "QA-FS FC" → "QF". Max two letters, upper case, empty-safe. */
export const clubInitials = (name) =>
  String(name || "")
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0))
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

export default clubInitials;
